module.exports = __webpack_public_path__ + "static/media/31-8.545bf264.mp3";